export default __webpack_public_path__ + "static/media/up-arrow.e0930d46.svg";